export default "__VITE_ASSET__97840054__"